<template>
  <v-container class="pa-0">
    <CountrySelector v-model="localInfluencers" label="Influencers" />
    <CountrySelector v-model="localInfluencees" label="Influencees" />
    <EventsPickerV3
      :useInfluence="true"
      :reset="reset"
      :selected-topics="localInfluences"
      @change="handleChangeInfluence"
    ></EventsPickerV3>
  </v-container>
</template>

<script>
import CountrySelector from "../common/CountrySelector.vue";
import EventsPickerV3 from "../events/EventsPickerV3.vue";

const EMITTED_ACTIONS = {
  CHANGE_INFLUENCES: "change-influences",
  CHANGE_INFLUENCERS: "change-influencers",
  CHANGE_INFLUENCEES: "change-influencees",
};

export default {
  name: "SearchFilterAnalysis",
  components: {
    CountrySelector: () => import("@/components/common/CountrySelector"),
    EventsPickerV3: () => import("@/components/events/EventsPickerV3"),
  },
  props: {
    reset: {
      type: String,
    },
    influences: {
      type: String,
    },
    influencees: {
      type: Array,
    },
    influencers: {
      type: Array,
    },
  },
  data() {
    return {
      localInfluences: null,
      localInfluencers: [],
      localInfluencees: [],
    };
  },
  async mounted() {
    this.localInfluencers = this.influencers;
    this.localInfluencees = this.influencees;
    this.localInfluences = this.influences;
  },
  methods: {
    updateLocalInfluencers(event) {
      this.$emit(EMITTED_ACTIONS.CHANGE_INFLUENCERS, event);
    },
    updateLocalInfluencees(event) {
      this.$emit(EMITTED_ACTIONS.CHANGE_INFLUENCEES, event);
    },
    handleChangeInfluence(event) {
      this.$emit(EMITTED_ACTIONS.CHANGE_INFLUENCES, event.selectedTopics);
    },
  },
  watch: {
    influencees: {
      handler() {
        this.localInfluencees = this.influencees;
      },
      deep: true,
    },
    localInfluencees: {
      handler() {
        this.$emit(EMITTED_ACTIONS.CHANGE_INFLUENCEES, this.localInfluencees);
      },
      deep: true,
    },
    influencers: {
      handler() {
        this.localInfluencers = this.influencers;
      },
    },
    localInfluencers: {
      handler() {
        this.$emit(EMITTED_ACTIONS.CHANGE_INFLUENCERS, this.localInfluencers);
      },
      deep: true,
    },
    influences: {
      handler() {
        this.localInfluences = this.influences;
      },
    },
    localInfluences: {
      handler() {
        this.$emit(EMITTED_ACTIONS.CHANGE_INFLUENCES, this.localInfluences);
      },
    },
    reset: {
      handler() {
        this.localInfluences = null;
        this.$emit(EMITTED_ACTIONS.CHANGE_INFLUENCES, this.localInfluences);
        this.localInfluencers = null;
        this.$emit(EMITTED_ACTIONS.CHANGE_INFLUENCERS, this.localInfluencers);
        this.localInfluencees = null;
        this.$emit(EMITTED_ACTIONS.CHANGE_INFLUENCEES, this.localInfluencees);
      },
    },
  },
  beforeDestroy() {
    this.localInfluences = null;
    this.localInfluencers = null;
    this.localInfluencees = null;
  },
};
</script>

<style scoped></style>
